import React from "react";
import {
  FormikErrors,
  FormikProps,
  useFormikContext,
  withFormik,
} from "formik";
import { Button } from "@chakra-ui/button";
import { HStack } from "@chakra-ui/layout";
import { AdminApiClient } from "../api/adminApiClient";
import { FormStack } from "../components/FormStack/FormStack";
import { TextArea } from "../components/fields/TextArea/TextArea";

const emptyStrToNull = (value: string | null): string | null => {
  if (!value || value.trim() === "") {
    return null;
  } else {
    return value;
  }
};

interface IntegrationDatasStoreFormValues {
  dataStore: string;
}

interface IntegrationDatasStoreFormProps {
  apiClient: AdminApiClient;
  businessId: string;
  integrationId: string;
  dataStore: { [key: string]: unknown } | null | undefined;
  isDisabled?: boolean;
  onCancel: () => void;
  onSuccess?: () => void;
  onFailure?: (message?: string) => void;
}

const InnerForm = ({
  isSubmitting,
  isDisabled,
  submitForm,
  isValid,
  onCancel,
  values,
}: IntegrationDatasStoreFormProps &
  FormikProps<IntegrationDatasStoreFormValues>) => {
  const { setFieldValue } = useFormikContext();
  const prettify = () => {
    const jsonObject = JSON.parse(values.dataStore);
    setFieldValue("dataStore", JSON.stringify(jsonObject, null, 2));
  };
  return (
    <FormStack>
      <TextArea
        label="Data Store"
        name="dataStore"
        rows={20}
        fontFamily="jsonTextArea"
      />

      <HStack width="100%" justifyContent="start" spacing="3" pt="4">
        <Button
          colorScheme="cherryButton"
          type="submit"
          isLoading={isSubmitting}
          disabled={isSubmitting || !isValid}
          onClick={submitForm}
        >
          Save
        </Button>
        <Button
          colorScheme="cherryButton"
          disabled={isSubmitting || !isValid}
          onClick={prettify}
        >
          Prettify
        </Button>
        <Button disabled={isSubmitting} onClick={onCancel}>
          Cancel
        </Button>
      </HStack>
    </FormStack>
  );
};

export const IntegrationDatasStoreForm = withFormik<
  IntegrationDatasStoreFormProps,
  IntegrationDatasStoreFormValues
>({
  mapPropsToValues: ({ dataStore }) => {
    return {
      dataStore: !dataStore ? "" : JSON.stringify(dataStore, null, 2),
    };
  },
  handleSubmit: async (values, { props, setFieldError }) => {
    let result = await props.apiClient.updateIntegrationDataStore(
      props.businessId,
      props.integrationId,
      emptyStrToNull(values.dataStore) == null
        ? null
        : JSON.parse(values.dataStore)
    );

    if (result.ok) {
      if (props.onSuccess) {
        props.onSuccess();
      }
    } else {
      if (props.onFailure) {
        props.onFailure(result.message);
      }
    }
  },

  validateOnBlur: false,
  validateOnMount: false,
  validateOnChange: true,
  validate: (values) => {
    let errors: FormikErrors<IntegrationDatasStoreFormValues> = {};

    try {
      if (emptyStrToNull(values.dataStore) != null)
        JSON.parse(values.dataStore);
    } catch (e) {
      errors.dataStore = "Invalid json format.";
    }

    return errors;
  },
})(InnerForm);
